<div class="chat-list-dialog">
  <div class="chat-dialog-header">
    <div class="chat-dialog-title" cdkFocusInitial>{{'CHAT.group_chats' | translate}}</div>

    <div class="dialog-header-buttons">
      <app-icon-button class="dialog-close-button" [ariaLabel]="'Close'" icon="x" (clicked)="closeDialog()"></app-icon-button>
    </div>
  </div>

  <app-chat-list
    class="chat-list"
    [chatMode]="mode"
    (channelsIntialized)="channelsLoaded($event)">
  </app-chat-list>

  @if (userHasChannels) {
    <div class="chat-dialog-footer">
      <button
        mat-flat-button
        [routerLink]="['/chat']"
        class="button button--transparent button--small chat-dialog-button">
        <lib-icon class="mr-2" icon="chats" size="24"></lib-icon>
        {{ 'CHAT.see_all_group_chats' | translate }}
      </button>
    </div>
  }

</div>
